/* Bundle builder: pool loader and range labelling.

   The eligible frames are fetched from the collection's own products.json in
   pages of 250, because Liquid caps a collection loop at 50 and the 25 KD
   range holds hundreds of frames. Order follows the collection's sort order.

   THE FETCH IS LOCALE-AWARE. products.json served from /collections/... is
   the English catalogue; the Arabic titles live at /ar/collections/... . The
   path here was absolute, so on the Arabic site the builder quietly loaded
   English data and every bundle card read "Freak | أسود" — the colour
   translated because it came from the product title, the family name not,
   because the whole title came from the English endpoint. The product data
   was correct all along; the URL was asking the wrong catalogue.

   window.SF_ROOT is set by Liquid from routes.root_url ('/' or '/ar'). It
   falls back to '' so nothing changes if the snippet is ever absent.

   Sold-out frames are dropped here rather than later, so a shopper can never
   pick one and hit a wall at checkout.

   ALL IMAGES are kept, not just the first. A bundle card is the only view of
   a frame a shopper gets — we deliberately do not send them to the product
   page mid-build — so the card has to show what the product page would: the
   folded shot, the detail, the one on a face.

   Both ids are kept. The variant id goes in the cart; the PRODUCT id is what
   the family grid lists in data-pids, and is how the bundle filters work out
   which family a frame belongs to.

   ---- THE TEMPORARY ADDITIONS, AND HOW THEY TAKE THEMSELVES OUT ----
   A group of 25 KD frames from the families grid was missing from Bundle
   range · 25 KD. They were added to that collection for a campaign running
   to 31 March 2027 — added to the collection itself, not just to this page,
   because the Buy X Get Y discounts that make 2 for 40 true are scoped to
   that collection. A frame shown here but not in it would be promised one
   price and charged another.

   That leaves the problem of taking them out again, which is the kind of
   thing that gets forgotten. They are therefore also listed in a second
   collection, bundle-range-25-temp, and sections/sf-bundles.liquid writes
   the date and whether it has passed into window.SF_BUNDLE_TEMP. Liquid
   does the comparison, not the browser, so a wrong clock on a phone cannot
   extend or shorten the campaign.

   BEFORE THE DATE NOTHING HAPPENS AT ALL — no extra request, no filtering.
   After it, that collection is fetched once and its products are removed
   from the pool here, so the bundles page stops offering them without
   anybody touching Shopify. Emptying or deleting that collection ends the
   arrangement early. Taking the frames back out of Bundle range · 25 KD is
   then optional tidying rather than a deadline.

   IT FAILS TOWARDS THE CAMPAIGN. If the exclusion list cannot be fetched,
   the pool is left as it is: showing a frame a day too long is a smaller
   fault than emptying the grid because one request failed. */
(function(){
"use strict";
window.SFBundleCache = window.SFBundleCache || {};
var EXCL = null;

/* '/ar' with no trailing slash, or '' on the English site. */
function root(){
  var r = window.SF_ROOT || '';
  return r === '/' ? '' : r.replace(/\/$/, '');
}

/* Resolves to a map of product ids to drop, or null while the campaign runs. */
function expiredIds(){
  var t = window.SF_BUNDLE_TEMP;
  if(!t || !t.expired || !t.collection) return Promise.resolve(null);
  if(EXCL) return EXCL;
  EXCL = fetch(root()+'/collections/'+t.collection+'/products.json?limit=250')
    .then(function(r){ return r.ok ? r.json() : {products:[]} })
    .then(function(j){
      var m = {};
      (j.products||[]).forEach(function(p){ m[p.id] = 1 });
      return m;
    })
    .catch(function(){ return {} });
  return EXCL;
}

window.SFBundlePool = function(handle, onProgress){
  var out=[], page=1, seen=0, dropped=0;
  function step(){
    return fetch(root()+'/collections/'+handle+'/products.json?limit=250&page='+page)
      .then(function(r){ return r.ok ? r.json() : {products:[]} })
      .then(function(j){
        var list=j.products||[];
        seen += list.length;
        list.forEach(function(p){
          var v=(p.variants||[])[0]; if(!v) return;
          if(v.available === false){ dropped++; return }
          var imgs=(p.images||[]).map(function(i){ return i.src }).filter(Boolean);
          out.push({
            id: v.id,
            pid: p.id,
            title: p.title,
            price: Math.round(parseFloat(v.price)*1000),
            img: imgs[0] || '',
            imgs: imgs.slice(0,8),
            /* The product link needs the locale prefix too, or a shopper on
               the Arabic site is dropped onto the English product page. */
            url: root()+'/products/'+p.handle,
            available: true
          });
        });
        if(onProgress) onProgress(out.length);
        if(list.length === 250 && page < 8){ page++; return step() }
        return finish();
      })
      .catch(function(){ return out });
  }
  function finish(){
    return expiredIds().then(function(drop){
      var final = out;
      if(drop){
        final = out.filter(function(p){ return !drop[p.pid] });
        final.expired = out.length - final.length;
      }
      final.seen = seen;
      final.soldOut = dropped;
      window.SFBundleCache[handle] = final;
      return final;
    });
  }
  return step();
};

window.SFBundleRange = function(b){
  if(b && b.range) return b.range;
  var h=(b&&b.collection)||'';
  var m=h.match(/bundle-range-([0-9]+)/);
  return m ? m[1]+' KD' : 'this';
};
})();